<template>
    <div class="campaign-card" @click="executeClick">
        <div class="campaign-image-container d-flex">
            <img class="campaign-image img font-sm align-self-center mx-auto"
                :src="'/image/' + productImage"
                @error="$root.imageAlt" alt="" />
        </div>
    </div>
</template>

<script>
    export default {
        props: ["campaign", "optionalProps"],
        computed: {
            productImage: function() {
                return this.campaign.imageId;
            },
            getOptionalProps: function() {
                return this.optionalProps;
            },
            campaignBaseDetails: function() {
                return {
                    'id': this.campaign.id,
                    'title': this.campaign.title
                }
            }
        },
        methods: {
            executeClick: function() {
                this.$router.push({
                    name: 'campaign',
                    query: Object.assign(this.campaignBaseDetails, this.getOptionalProps)
                });
            }

        }
    }
</script>
